import React, { useRef } from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { WarningOutlined, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import Finalizar from './modalJustificativa';
import { PropsRefFinalizarAgendamento } from './modalJustificativa';
import { ROLE } from 'utils/roles';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

const ModalCancelarPedido: React.FC<any> = ({ record }) => {
  const finalizarRef = useRef<PropsRefFinalizarAgendamento>(null);

  const confirmarCancelarPedido = async () => {
    Modal.confirm({
      title: 'Atenção',
      icon: <WarningOutlined />,
      content: (
        <p>
          Tem certeza que deseja cancelar o agendamento nº {record?.codAgendamento}? Essa ação não
          poderá ser desfeita.
        </p>
      ),
      okText: 'Sim, quero cancelar',

      cancelText: 'Não',
      centered: true,

      async onOk() {
        if (finalizarRef?.current) {
          finalizarRef.current.showModal();
        }
      },
    });
  };
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const isValidExp = record.status === 'EXP';
  const isValidDate =
    record?.dhAgendamento && moment(record?.dhAgendamento).format() <= moment().format();
  const isAdm = perfil === ROLE.ADMINISTRADOR;

  return (
    <>
      <Tooltip
        title={
          isValidExp
            ? 'Esse agendamento já foi expedido, não pode ser cancelado.'
            : isValidDate
            ? !isAdm && 'Agendamentos com data retroativa não podem ser cancelados.'
            : ''
        }
        placement="left"
        color="#090909"
      >
        <Button
          style={{ display: 'block', width: '100%', border: '1px solid #ddd' }}
          disabled={isValidExp || (!isAdm && isValidDate)}
          onClick={() => confirmarCancelarPedido()}
          type="text"
          icon={<CloseOutlined />}
        >
          Cancelar
        </Button>
        <Finalizar ref={finalizarRef} codAgendamento={record?.codAgendamento} />
      </Tooltip>
    </>
  );
};

export default ModalCancelarPedido;
